import { motion } from "framer-motion";
import { MessageCircle, Mail, Phone, ArrowUpRight } from "lucide-react";
import { CONTACT } from "./data";
import { Reveal, Eyebrow } from "./Reveal";
import { Logo } from "./Logo";

const LINKS = [
  { Icon: MessageCircle, label: "WhatsApp", value: "Scrie-ne acum", href: CONTACT.whatsapp, testid: "contact-whatsapp-btn" },
  { Icon: Mail, label: "E-mail", value: CONTACT.email, href: CONTACT.emailHref, testid: "contact-email-btn" },
  { Icon: Phone, label: "Telefon", value: CONTACT.phone, href: CONTACT.phoneHref, testid: "contact-phone-btn" },
];

export const Contact = () => (
  <section id="contact" data-testid="contact-cta-section" className="grain relative bg-[#0B1120] text-white overflow-hidden">
    <div className="absolute -bottom-40 -left-40 w-[600px] h-[600px] rounded-full bg-[#1F6F99]/40 blur-[140px] pointer-events-none" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 pt-24 sm:pt-36 pb-12">
      <Reveal>
        <Eyebrow light>Contact</Eyebrow>
        <h2 className="mt-6 font-display text-5xl sm:text-6xl lg:text-8xl font-semibold leading-[0.98] tracking-[-0.02em] max-w-5xl">
          Hai să strângem <span className="italic font-black text-[#A8DCF2]">stele</span> împreună.
        </h2>
        <p className="mt-8 max-w-lg text-slate-300 text-base sm:text-lg leading-relaxed">Spune-ne ce afacere ai și câte bucăți îți trebuie. Îți răspundem cu oferta și termenul de livrare.</p>
      </Reveal>

      <div className="mt-16 grid md:grid-cols-3 border-t border-white/15">
        {LINKS.map((l, i) => (
          <Reveal key={l.label} delay={i * 0.08}>
            <motion.a whileHover="hover" href={l.href} target={l.label === "WhatsApp" ? "_blank" : undefined} rel="noreferrer" data-testid={l.testid} className="group flex items-start justify-between gap-4 py-8 md:px-6 md:first:pl-0 border-b md:border-b-0 md:border-r border-white/15 hover:bg-white/[0.03] transition-colors">
              <div>
                <l.Icon className="w-5 h-5 text-[#A8DCF2]" />
                <p className="mt-6 font-mono text-xs uppercase tracking-widest text-slate-400">{l.label}</p>
                <p className="mt-2 font-display text-xl sm:text-2xl break-all">{l.value}</p>
              </div>
              <motion.span variants={{ hover: { rotate: 45 } }}><ArrowUpRight className="w-6 h-6 text-[#A8DCF2]" /></motion.span>
            </motion.a>
          </Reveal>
        ))}
      </div>

      <footer data-testid="footer-section" className="mt-24 flex flex-col sm:flex-row gap-6 sm:items-center justify-between text-sm text-slate-400">
        <Logo dark testid="footer-logo" />
        <p>{CONTACT.city}</p>
        <p>© {new Date().getFullYear()} EasyREW. Toate drepturile rezervate.</p>
      </footer>
    </div>
  </section>
);
